import LongFormArticleTemplate from '@/components/LongFormArticleTemplate';
import { nycPages } from '@/data/nycPages';

export default function NycLegalGuardianshipForSpecialNeedsChildPage() {
  return <LongFormArticleTemplate page={nycPages['/nyc-legal-guardianship-for-special-needs-child/']} />;
}
